<template>
    <div>
        <div id="stripe-payment-element" />
    </div>
</template>

<script>
import { buildStripeAppearance } from '@/utils/stripeAppearance.util';
import { loadStripe } from '@stripe/stripe-js';

export default {
    props: {
        contactId: {
            type: String,
            required: true,
        },
        clientSecret: {
            type: String,
            required: true,
        },
        sessionKey: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            stripe: null,
            elements: null,
            setupIntentId: null,
        };
    },
    async mounted() {
        this.stripe = await loadStripe(this.sessionKey);
        if (!this.stripe) return;

        this.elements = this.stripe.elements({ clientSecret: this.clientSecret, appearance: buildStripeAppearance() });
        const paymentElement = this.elements.create('payment', { layout: { type: 'tabs' }, wallets: { link: 'never' } });

        paymentElement.mount('#stripe-payment-element');

        document.getElementById('stripePaymentMethodForm').addEventListener('stripe-submit', this.handleSubmit);
    },

    beforeDestroy() {
        const form = document.getElementById('stripePaymentMethodForm');

        if (form) {
            form.removeEventListener('stripe-submit', this.handleSubmit);
        }
    },

    methods: {
        async handleSubmit() {
            if (!this.elements) return;

            try {
                const setupIntent = await this.confirmStripeSetup();

                document.querySelector('[name="paymentToken"]').value = setupIntent.payment_method;
                document.querySelector('[name="setupIntentId"]').value = setupIntent.id;
                document.querySelector('[name="identifier"]').value = 'Stripe'
                document.getElementById('creditCardForm').submit();
            } catch (e) {
                const url = new URL(window.location.href);

                url.searchParams.set('error', e.message);
                window.location.href = url.toString();
            }
        },

        async confirmStripeSetup() {
            const { error: submitError } = await this.elements.submit();

            if (submitError) throw new Error(submitError.message);

            const { setupIntent, error: confirmError } = await this.stripe.confirmSetup({
                elements: this.elements,
                redirect: 'if_required',
                confirmParams: { return_url: window.location.href },
            });

            if (confirmError) throw new Error(confirmError.message);

            return setupIntent;
        },
    }
}
</script>
